{
  "title": "Pul kisəsi",
  "subtitle": "Balans yalnız serverdən oxunur. Real əməliyyatlar aktivləşdirilməyib.",
  "real": "Əsas balans",
  "bonus": "Bonus",
  "reserved": "Rezerv",
  "unavailable": "Balans məlumatı əlçatan deyil",
  "deposit": "Depozit",
  "withdraw": "Çıxarış",
  "history": "Tarixçə",
  "comingSoon": "Ödəniş axınları tezliklə"
}
